import { boolean, number, object } from 'yup';

export function validationSchema() {
  return object().shape({
    EdgeAgentCheckinInterval: number().required('Обязательное поле.'),
    EnableEdgeComputeFeatures: boolean().required('Обязательное поле.'),
    DisableTrustOnFirstConnect: boolean().required('Обязательное поле.'),
    EnforceEdgeID: boolean().required('Обязательное поле.'),
  });
}
